export default class FilterSizeGroup extends HTMLElement {
  private toggle: HTMLInputElement | null = null;
  private variants: HTMLInputElement[] = [];

  private onToggleChangeBound = this.onToggleChange.bind(this);

  connectedCallback(): void {
    this.toggle = this.querySelector('[data-filter-size-group-ref="toggle"]');
    this.variants = Array.from(this.querySelectorAll<HTMLInputElement>('[data-filter-size-group-ref="variant"]'));

    this.addEventListeners();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }

  private addEventListeners(): void {
    this.toggle?.addEventListener('change', this.onToggleChangeBound);
  }

  private removeEventListeners(): void {
    this.toggle?.removeEventListener('change', this.onToggleChangeBound);
  }

  private onToggleChange(): void {
    if (!this.toggle) {
      return;
    }

    const isChecked = this.toggle.checked;

    this.variants.forEach((variant) => {
      if (variant.disabled) {
        return;
      }

      variant.checked = isChecked;
    });

    this.closest('form')?.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('filter-size-group', FilterSizeGroup);
